import { render, staticRenderFns } from "./DialogAddLecturesFeedbackStatement.vue?vue&type=template&id=7d8d392c"
import script from "./DialogAddLecturesFeedbackStatement.vue?vue&type=script&lang=js"
export * from "./DialogAddLecturesFeedbackStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d8d392c')) {
      api.createRecord('7d8d392c', component.options)
    } else {
      api.reload('7d8d392c', component.options)
    }
    module.hot.accept("./DialogAddLecturesFeedbackStatement.vue?vue&type=template&id=7d8d392c", function () {
      api.rerender('7d8d392c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLecturesFeedbackStatement.vue"
export default component.exports